import Box from '@eversports/klimt-primitives/legacy/Box'
import Icon from '@eversports/klimt-primitives/legacy/Icon'

import FilterIcon from '../../../assets/icons/filter.svg'

interface Props {
  isActive: boolean
  openFilters: () => void
}

const MobileMoreFilters = ({ isActive, openFilters }: Props) => (
  <Box
    onClick={openFilters}
    sx={{
      border: '1px solid',
      borderColor: isActive ? 'primary.main' : 'mediumgray',
      borderRadius: 1,
      p: 2.5,
      ml: 'auto',
      cursor: 'pointer',
      height: 'min-content',
    }}
  >
    <Icon src={FilterIcon} size="small" color={isActive ? 'primary' : 'black'} />
  </Box>
)

export default MobileMoreFilters
